var parent = require('../../es/instance/every');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/every.js
// module id = 1110
// module chunks = 0